import { render } from "./MoodMatchList.vue?vue&type=template&id=2364e84a&scoped=true"
import script from "./MoodMatchList.vue?vue&type=script&lang=js"
export * from "./MoodMatchList.vue?vue&type=script&lang=js"

import "./MoodMatchList.vue?vue&type=style&index=0&id=2364e84a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2364e84a"]])

export default __exports__